export const levels1 = {
  北京: [ "零起点", "7级-6级", "6级-5级", "4级-3级", "3级-2级", "1级-1段", "2段", "3段", "3段-4段", "4段", "4段-5段", "5段", "5段-6段","5段-6段"],
  上海: [ "零起点", "12级-11级", "11级-10级", "9级-6级", "5级-2级", "1级-1段", "2段-3段", "3段-4段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  广州: [ "零起点", "30级-20级", "15级-10级", "8级-5级", "5级-1级", "1段-2段", "3段", "4段", "4段-5段", "5段", "5段", "5段", "5段-6段","5段-6段"],
  深圳: [ "零起点", "9级-8级", "8级-6级", "6级-4级", "3级-1级", "1段-2段", "3段", "4段", "4段-5段", "5段", "5段", "5段", "5段-6段","5段-6段"],
  天津: [ "零起点", "9级-8级", "8级-6级", "6级-4级", "3级-1级", "1段", "2段", "3段", "3段-4段", "4段", "4段-5段", "5段", "5段-6段","5段-6段"],
  山东: [ "零起点", "25级-20级", "15级-10级", "5级-2级", "2级-1级", "1段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  江苏: [ "零起点", "12级-11级", "10级-9级", "8级-5级", "4级-1级", "1段-2段", "3段", "4段", "4段-5段", "5段", "5段", "5段", "5段-6段","5段-6段"],
  浙江: [ "零起点", "16级-15级", "15级-9级", "8级-4级", "3级-1级", "1级-1段", "2段", "3段", "3段-4段", "4段", "4段-5段", "5段", "5段-6段","5段-6段"],
  福建: [ "零起点", "25级", "25级-20级", "15级-5级", "5级-2级", "1级-1段", "1段-2段", "2段-3段", "3段", "3段-4段", "4段", "4段-5段", "5段-6段","5段-6段"],
  广东: [ "零起点", "30级-20级", "15级-10级", "8级-5级", "5级-1级", "1级-2段", "3段", "4段", "4段-5段", "5段", "5段", "5段", "5段-6段","5段-6段"],
  河北: [ "零起点", "9级", "8级-6级", "6级-4级", "3级-1级", "1段", "2段", "3段", "3段-4段", "4段", "5段", "5段", "5段-6段","5段-6段"],
  辽宁: [ "零起点", "25级-20级", "15级-10级", "10级-5级", "2级-1级", "1段-2段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  吉林: [ "零起点", "10级-9级", "8级-6级", "6级-4级", "3级-1级", "1级-1段", "2段", "3段", "3段-4段", "4段", "4段-5段", "5段", "5段-6段","5段-6段"],
  黑龙江: [ "零起点", "20级-15级", "15级-10级", "10级-5级", "5级-2级", "1级-1段", "2段", "3段", "3段-4段", "4段", "4段-5段", "5段", "5段-6段","5段-6段"],
  山西: [ "零起点", "6级-5级", "5级-3级", "3级-1级", "1级-1段", "1段", "2段", "2段-3段", "3段-4段", "4段", "4段-5段", "5段", "5段-6段","5段-6段"],
  陕西: [ "零起点", "25级-15级", "15级-10级", "5级-2级", "2级-1段", "1段-2段", "2段-3段", "3段-4段", "4段-5段", "5段", "5段", "5段", "5段-6段","5段-6段"],
  河南: [ "零起点-20级", "15级", "10级", "5级", "2级-1级", "1级-1段", "1段-2段", "2段-3段", "3段", "3段-4段", "4段", "4段-5段", "5段-6段","5段-6段"],
  安徽: [ "零起点", "4级-3级", "3级-2级", "2级-1级", "1段", "2段", "3段", "3段-4段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  江西: [ "零起点", "20级-15级", "15级-10级", "5级-3级", "2级-1级", "1段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  湖南: [ "零起点", "9级", "5级-4级", "4级-2级", "1级-1段", "1段-2段", "3段", "4段", "4段-5段", "5段", "5段", "5段", "5段-6段","5段-6段"],
  湖北: [ "零起点", "15级-10级", "9级-6级", "5级-3级", "2级-1级", "1段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  广西: [ "零起点", "9级-8级", "7级-6级", "5级-3级", "2级-1级", "1段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  四川: [ "零起点", "25级", "20级-15级", "10级-5级", "2级-1级", "1段", "1段-2段", "3段", "3段-4段", "4段", "4段-5段", "5段", "5段-6段","5段-6段"],
  贵州: [ "零起点", "15级", "10级", "5级", "2级-1级", "1段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  云南: [ "零起点", "9级", "8级-7级", "6级-4级", "3级-1级", "1段-2段", "2段-3段", "3段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  海南: [ "零起点", "20级-15级", "10级", "5级", "2级-1级", "1段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  重庆: [ "零起点", "25级-18级", "18级-13级", "12级-5级", "5级-2级", "1级-1段", "1段-2段", "3段", "3段-4段", "4段", "4段-5段", "5段", "5段-6段","5段-6段"],
  内蒙古: [ "零起点", "25级-20级", "15级-10级", "5级-1级", "1级-1段", "2段", "3段", "3段-4段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  甘肃: [ "零起点", "25级-20级", "15级-10级", "5级", "2级-1级", "1段-2段", "2段-3段", "3段-4段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  宁夏: [ "零起点", "25级-20级", "20级-10级", "9级-4级", "4级-1级", "1段", "2段-3段", "3段-4段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  青海: [ "零起点", "25级-20级", "15级-10级", "5级-2级", "1级-1段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段", "5段-6段","5段-6段"],
  新疆: [ "零起点", "25级-20级", "15级-10级", "5级-2级", "1级-1段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段", "5段-6段","5段-6段"],
  西藏: [ "零起点", "15级", "10级", "5级", "2级-1级", "1段", "2段", "3段", "4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
  港澳台: [ "零起点", "30级-28级", "27级-21级", "20级-10级", "10级-5级", "2级-1段", "2段", "3段", "3段-4段", "4段-5段", "5段", "5段", "5段-6段","5段-6段"],
};

export var levels2 = {
  北京: ["5级-1段", "1段-3段", "3段-4段", "4段-5段"],
  上海: ["5级-1段", "2段-4段", "4段-5段", "5段"],
  广州: ["5级-2段", "3段-4段", "4段-5段", "5段"],
  深圳: ["5级-2段", "3段-4段", "4段-5段", "5段"],
  天津: ["5级-1段", "1段-3段", "3段-4段", "4段-5段"],
  山东: ["5级-1段", "1段-3段", "3段-4段", "4段-5段"],
  江苏: ["5级-2段", "3段-4段", "4段-5段", "5段"],
  浙江: ["5级-1段", "2段-3段", "3段-4段", "4段-5段"],
  福建: ["5级-1段", "1段-3段", "3段-4段", "4段-4段"],
  广东: ["5级-2段", "3段-4段", "4段-5段", "5段"],
  河北: ["3级-2段", "2段-3段", "3段-4段", "4段-5段"],
  辽宁: ["3级-2段", "2段-3段", "4段-5段", "5段"],
  吉林: ["3级-1段", "2段-3段", "3段-4段", "4段-5段"],
  黑龙江: ["5级-1段", "2段-3段", "3段-4段", "4段-5段"],
  山西: ["1级-1段", "2段-3段", "3段-4段", "4段-4段"],
  陕西: ["5级-2段", "2段-4段", "4段-5段", "5段"],
  河南: ["5级-1段", "1段-3段", "3段-4段", "4段-4段"],
  安徽: ["2级-1段", "2段-3段", "4段-5段", "5段"],
  江西: ["5级-1段", "2段-3段", "4段-5段", "5段"],
  湖南: ["3级-2段", "3段-4段", "4段-5段", "5段"],
  湖北: ["5级-1段", "2段-3段", "4段-5段", "5段"],
  广西: ["3级-1段", "2段-3段", "4段-5段", "5段"],
  四川: ["5级-1段", "1段-3段", "3段-4段", "4段-5段"],
  贵州: ["5级-1段", "2段-3段", "4段-5段", "5段"],
  云南: ["4级-2段", "3段-4段", "4段-5段", "5段"],
  海南: ["3级-1段", "2段-3段", "4段-5段", "5段"],
  重庆: ["5级-1段", "1段-3段", "3段-4段", "4段-5段"],
  内蒙古: ["5级-1段", "2段-3段", "4段-5段", "5段"],
  甘肃: ["5级-1段", "2段-4段", "4段-5段", "5段"],
  宁夏: ["4级-1段", "2段-4段", "4段-5段", "5段"],
  青海: ["5级-2段", "3段-4段", "4段-5段", "5段"],
  新疆: ["5级-2段", "2段-4段", "4段-5段", "5段"],
  西藏: ["5级-2段", "2段-4段", "4段-5段", "5段"],
  港澳台: ["5级-2段", "2段-4段", "4段-5段", "5段"],
};
